import { redirect } from "@tanstack/react-router";
import { backendFetch } from "@softmax/observatory-client/transport";
import { buildHref } from "@softmax/web-addresses";
import type { useBrowserSession } from "@softmax/web-features/session";

type BrowserSession = NonNullable<
  ReturnType<typeof useBrowserSession>["session"]
>;

export function getAuthSession({
  signal,
}: {
  signal?: AbortSignal | undefined;
} = {}): Promise<BrowserSession | null> {
  return backendFetch("", "/api/auth/session", {
    signal: signal ?? null,
    cache: "no-store",
  });
}

export async function requireAuthSession({
  returnHref,
  signal,
}: {
  returnHref: string;
  signal?: AbortSignal | undefined;
}): Promise<BrowserSession> {
  const session = await getAuthSession({ signal });

  if (!session) {
    throw redirect({
      href: buildHref({
        name: "signIn",
        search: new URLSearchParams({ redirect_url: returnHref }),
      }),
    });
  }

  return session;
}
